export default "/assets/images/critter-cuddler2.018ca9a0e642fc08.png";